import { Button, forwardRef, Link, type ButtonProps } from '@/ui';
import { getAuthUrl, type GetAuthUrlArg } from '../auth.lib';
import { CanvaIcon } from './CanvaIcon';

export const DecoratedButton = forwardRef<ButtonProps, typeof Button>(
  (props, ref) => {
    return (
      <Button
        _hover={{ textDecor: 'none', bg: 'customgray.lightest' }}
        bg="white"
        color="black"
        colorScheme="white"
        fontSize="sm"
        fontWeight="bold"
        leftIcon={<CanvaIcon />}
        ref={ref}
        shadow="0px 0px 8px 2px rgba(0, 0, 0, 0.10)"
        size={{ base: 'xs', sm: 'md' }}
        {...props}
      />
    );
  }
);

export const ConnectButton = (authUrlOptions: GetAuthUrlArg) => {
  return (
    <DecoratedButton as={Link} href={getAuthUrl(authUrlOptions)}>
      Connect Canva
    </DecoratedButton>
  );
};
